import React from "react";
import tw from "tailwind-styled-components";
import { useFormik } from "formik";
import Loading from "../Loading";
import { InputGroup, Label, SubmitBtn } from "../Styles/InputStyles";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Model from "../Model";
import * as Yup from "yup";
// import { toast } from "react-toastify";

const EditReminder = ({
    editReminderMutate,
    editReminderLoading,
    setEditReminder,
    selectedData,
})=>{
const SubmitHandler = (values) => {
    editReminderMutate(values);
    };

    const formik = useFormik({
    initialValues: {
        canDoStaffEkyc: selectedData?.canDoStaffEkyc || 0,
        canDoTenantEkyc: selectedData?.canDoTenantEkyc || 0,
        tenantAttendanceEnabled: selectedData?.tenantAttendanceEnabled || 0,
        canTenantRequestRoom: selectedData?.canTenantRequestRoom || 0,
        canPayLandlord: selectedData?.canPayLandlord || 0,
        canSendRentReminderToAll: selectedData?.canSendRentReminderToAll || 0,
        gstNo: selectedData?.gstNo || "",
    },
    validationSchema: Yup.object().shape({
        canDoStaffEkyc: Yup.number().required("Select an option"),
        canDoTenantEkyc: Yup.number().required("Select an option"),
        tenantAttendanceEnabled: Yup.number().required("Select an option"),
        canTenantRequestRoom: Yup.number().required("Select an option"),
        canPayLandlord: Yup.number().required("Select an option"),
        canSendRentReminderToAll: Yup.number().required("Select an option"),
    }),
    onSubmit: SubmitHandler,
    enableReinitialize: true,
    });

    return (
    <Model width={`w-11/12 max-w-lg`} setOpenModel={setEditReminder}>
      {editReminderLoading ? (
        <div className="w-full h-full">
          <Loading />
        </div>
      ) : (
        <Wrapper>
          <Title>Edit Reminder</Title>
          <form onSubmit={formik.handleSubmit}>
            <Wrapper>
              <CombineInputGroup>
                <InputGroup>
                  <Label htmlFor="canDoStaffEkyc">Can Do Staff Ekyc</Label>
                  <FieldWrapper $select={true}>
                    <Select
                      name="canDoStaffEkyc"
                      id="canDoStaffEkyc"
                      value={formik.values.canDoStaffEkyc}
                      onChange={formik.handleChange}
                      className="w-full pl-2"
                      style={{ height: "40px" }}
                      displayEmpty
                    >
                      <MenuItem value="0">No</MenuItem>
                      <MenuItem value="1">Yes</MenuItem>
                    </Select>
                    {formik.touched.canDoStaffEkyc &&
                      formik.errors.canDoStaffEkyc && (
                        <p className="text-rose-600 text-sm">
                          {formik.errors.canDoStaffEkyc}
                        </p>
                      )}
                  </FieldWrapper>
                </InputGroup>

                <InputGroup>
                  <Label htmlFor="canDoTenantEkyc">Can Do Tenant Ekyc</Label>
                  <FieldWrapper $select={true}>
                    <Select
                      name="canDoTenantEkyc"
                      id="canDoTenantEkyc"
                      value={formik.values.canDoTenantEkyc}
                      onChange={formik.handleChange}
                      className="w-full pl-2"
                      style={{ height: "40px" }}
                      displayEmpty
                    >
                      <MenuItem value="0">No</MenuItem>
                      <MenuItem value="1">Yes</MenuItem>
                    </Select>
                    {formik.touched.canDoTenantEkyc &&
                      formik.errors.canDoTenantEkyc && (
                        <p className="text-rose-600 text-sm">
                          {formik.errors.canDoTenantEkyc}
                        </p>
                      )}
                  </FieldWrapper>
                </InputGroup>
              </CombineInputGroup>

              <CombineInputGroup>
                <InputGroup>
                  <Label htmlFor="canTenantRequestRoom">Can Tenant Request Room</Label>
                  <FieldWrapper $select={true}>
                    <Select
                      name="canTenantRequestRoom"
                      id="canTenantRequestRoom"
                      value={formik.values.canTenantRequestRoom}
                      onChange={formik.handleChange}
                      className="w-full pl-2"
                      style={{ height: "40px" }}
                      displayEmpty
                    >
                      <MenuItem value="0">No</MenuItem>
                      <MenuItem value="1">Yes</MenuItem>
                    </Select>
                    {formik.touched.canTenantRequestRoom &&
                      formik.errors.canTenantRequestRoom && (
                        <p className="text-rose-600 text-sm">
                          {formik.errors.canTenantRequestRoom}
                        </p>
                      )}
                  </FieldWrapper>
                </InputGroup>

                <InputGroup>
                  <Label htmlFor="canPayLandlord">Can Pay Landlord Online</Label>
                  <FieldWrapper $select={true}>
                    <Select
                      name="canPayLandlord"
                      id="canPayLandlord"
                      value={formik.values.canPayLandlord}
                      onChange={formik.handleChange}
                      className="w-full pl-2"
                      style={{ height: "40px" }}
                      displayEmpty
                    >
                      <MenuItem value="0">No</MenuItem>
                      <MenuItem value="1">Yes</MenuItem>
                    </Select>
                    {formik.touched.canPayLandlord &&
                      formik.errors.canPayLandlord && (
                        <p className="text-rose-600 text-sm">
                          {formik.errors.canPayLandlord}
                        </p>
                      )}
                  </FieldWrapper>
                </InputGroup>
              </CombineInputGroup>

              <CombineInputGroup>
                <InputGroup>
                    <Label htmlFor="tenantAttendanceEnabled">Tenant Attendance Enabled</Label>
                    <FieldWrapper $select={true}>
                      <Select
                        name="tenantAttendanceEnabled"
                        id="tenantAttendanceEnabled"
                        value={formik.values.tenantAttendanceEnabled}
                        onChange={formik.handleChange}
                        className="w-full pl-2"
                        style={{ height: "40px" }}
                        displayEmpty
                      >
                        <MenuItem value="0">No</MenuItem>
                        <MenuItem value="1">Yes</MenuItem>
                      </Select>
                      {formik.touched.tenantAttendanceEnabled &&
                        formik.errors.tenantAttendanceEnabled && (
                          <p className="text-rose-600 text-sm">
                            {formik.errors.tenantAttendanceEnabled}
                          </p>
                        )}
                    </FieldWrapper>
                  </InputGroup>

                  <InputGroup>
                    <Label htmlFor="canSendRentReminderToAll">Can Send Rent Reminder To All</Label>
                    <FieldWrapper $select={true}>
                      <Select
                        name="canSendRentReminderToAll"
                        id="canSendRentReminderToAll"
                        value={formik.values.canSendRentReminderToAll}
                        onChange={formik.handleChange}
                        className="w-full pl-2"
                        style={{ height: "40px" }}
                        displayEmpty
                      >
                        <MenuItem value="0">No</MenuItem>
                        <MenuItem value="1">Yes</MenuItem>
                      </Select>
                      {formik.touched.canSendRentReminderToAll &&
                        formik.errors.canSendRentReminderToAll && (
                          <p className="text-rose-600 text-sm">
                            {formik.errors.canSendRentReminderToAll}
                          </p>
                        )}
                    </FieldWrapper>
                  </InputGroup>
                  </CombineInputGroup>
            </Wrapper>

            <BtnWrapper>
              <SubmitBtn type="submit">Update</SubmitBtn>
            </BtnWrapper>
          </form>
        </Wrapper>
      )}
    </Model>
  );
};

const BtnWrapper = tw.div`w-full flex items-center justify-center space-x-10 mt-8`;
const Title = tw.h2`text-lg md:text-xl lg:text-2xl text-gray-600 font-medium mb-6 text-center`;
const Wrapper = tw.div`px-1  space-y-4`;
const FieldWrapper = tw.div`w-full`;
const CombineInputGroup = tw.div`flex space-x-7`;
const Input = tw.input`truncate border border-gray-300 border-m rounded pl-2 focus:ring-1 focus:ring-sky-600 focus:border-sky-600 focus:outline-none duration-200`;
export default EditReminder;